import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import {
  adjustToTimeZoneSafely,
  getObjectId,
  type RrcCompanyProfile,
} from '@ots-frontend/ots-data';
import { RrcCompanyProfileInspector } from '@ots-frontend/ots-ui-tw';
import type { RrcCompanyProfileFormDefaultValues } from '../rrc-profile-route-defaults';

type Props = {
  id?: string;
  copy?: boolean;
  formDefaults?: RrcCompanyProfileFormDefaultValues;
};

/** Preserve legacy navigation defaults while the shared form works with plain API values. */
export const companyProfileRouteDefaults = (
  value?: RrcCompanyProfileFormDefaultValues
): Partial<RrcCompanyProfile> | undefined =>
  value
    ? {
        companyId: getObjectId(value.company),
        companyName:
          typeof value.company === 'object'
            ? value.company.displayName
            : undefined,
        rrcDistrict: value.rrcDistrict?.code,
        role: value.role?.code,
        effectiveStartDttm: adjustToTimeZoneSafely(
          value.effectiveStartDate
        )?.getTime(),
        effectiveEndDttm: adjustToTimeZoneSafely(
          value.effectiveEndDate
        )?.getTime(),
        orgName: value.orgName,
        commercial: value.commercial,
        p5Number: value.p5Number,
        permitNumber: value.permitNumber,
        contactName: value.contactName,
        contactPhone: value.contactPhone,
        contactEmail: value.contactEmail,
        address: value.address,
        autoEp9SignerId: getObjectId(value.autoEp9Signer),
        autoEp9SignerStrategy: value.autoEp9SignerStrategy?.code,
        autoEp10SignerId: getObjectId(value.autoEp10Signer),
        autoEp10SignerStrategy: value.autoEp10SignerStrategy?.code,
      }
    : undefined;

export const RrcCompanyProfileFormPageRoute = () => {
  const { state } = useLocation();
  const [params] = useSearchParams();
  return (
    <RrcCompanyProfileFormPage
      id={state?.id ?? params.get('id') ?? undefined}
      copy={state?.copy}
      formDefaults={state?.formDefaults}
    />
  );
};
export const RrcCompanyProfileFormPage = ({
  id,
  copy,
  formDefaults,
}: Props) => {
  const navigate = useNavigate();
  return (
    <RrcCompanyProfileInspector
      id={id}
      initialMode={copy ? 'copy' : id ? 'edit' : 'create'}
      defaults={companyProfileRouteDefaults(formDefaults)}
      companyLocked={!!formDefaults?.company}
      presentation="embedded"
      onClose={() => navigate(-1)}
    />
  );
};
